// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gridSizeCell[data-v-710dcd70]{font-variant-numeric:tabular-nums;font-family:var(--link-font-mono,ui-monospace,monospace)}.cellMuted[data-v-710dcd70],.gridSizeCell[data-v-710dcd70]{color:var(--link-ink-secondary)}", ""]);
// Exports
module.exports = exports;
